import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const DirectorNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Director Not Found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default DirectorNotFound



// WEBPACK FOOTER //
// ./src/components/Directors/DirectorNotFound.jsx